import { useState } from "react";
import PinSection from "./components/PinSection";
import ChangePinModal from "./components/modals/ChangePinModal";
import { useOtpBlockCountdown } from "../../hooks/useOtpBlockCountdown";
import { OtpBlockBanner } from "../shared/OtpBlockBanner";
import { usePinLockedStore } from "../../stores/useOtpBlockStore";

export default function SecurityTab() {
  const [changePinOpened, setChangePinOpened] = useState(false);
  const { isBlocked, countdown } = useOtpBlockCountdown(usePinLockedStore);

  return (
    <div>
      {isBlocked && (
        <OtpBlockBanner
          countdown={countdown}
          title="PIN Locked"
          message={`Your PIN has been locked for security reasons. Try again in ${countdown}, or contact customer support to continue.`}
          fullWidth
        />
      )}
      <div className="flex flex-col gap-8">
        <PinSection
          onChangeClick={() => setChangePinOpened(true)}
          disabled={isBlocked}
        />
        <ChangePinModal
          opened={changePinOpened}
          onClose={() => setChangePinOpened(false)}
        />
      </div>
    </div>
  );
}
